import React, { useState } from "react";
import { Box, Button, Divider, Typography } from "@mui/material";
import LoginForm from "features/auth/login-form";
import SignUpForm from "features/auth/signup-form";
import { styled } from "@mui/system";
import LoginImage from "assets/images/home/login/login-page-image.png";
import { SEO } from "components/seo";

export const StyledAppBar = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  "& .lower-button": {
    color: theme.palette.primary.orange,
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  "& .signin-container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "fit-content",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

const Login = () => {
  const [showLoginForm, setShowLoginForm] = useState(true);
  const handleToggleForm = () => {
    setShowLoginForm(!showLoginForm);
  };

  return (
    <>
      <SEO
        title={
          showLoginForm
            ? "Prime Solution | 로그인"
            : "Prime Solution | 회원가입"
        }
        description="Prime Solution 로그인 페이지"
      />
      <StyledAppBar>
        <Box
          sx={(theme) => ({
            px: 4,
            py: 8,
            display: "flex",
            flexDirection: "row",
            gap: "7rem",
            alignItems: "center",
            minHeight: "100vh",
          })}
        >
          <Box
            sx={(theme) => ({
              height: "50vh",
              width: "40vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: theme.palette.gray.main,
              borderRadius: "1rem",
              padding: "1rem",
              backgroundImage: `url(${LoginImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              [theme.breakpoints.down("lg")]: {
                height: "60vh",
                width: "50vh",
              },
              [theme.breakpoints.down("md")]: {
                height: "50vh",
                width: "40vh",
              },
              [theme.breakpoints.down("sm")]: {
                display: "none",
              },
            })}
          />
          <Box display="flex" flexDirection="column">
            <Box>{showLoginForm ? <LoginForm /> : <SignUpForm />}</Box>
            <Divider sx={{ width: "100%", marginTop: "1rem" }} component="div">
              <Typography
                variant="body"
                sx={{
                  color: "gray",
                  margin: "1rem",
                }}
              >
                또는
              </Typography>
            </Divider>
            <Box mt={2} className="signin-container">
              <Typography
                variant="body"
                sx={{
                  color: "gray",
                  marginRight: "0.5rem",
                }}
              >
                {showLoginForm
                  ? "계정이 없으신가요?"
                  : "이미 계정이 있으신가요?"}
              </Typography>
              <Button onClick={handleToggleForm} className="lower-button">
                {showLoginForm ? (
                  <Typography variant="body">회원 가입</Typography>
                ) : (
                  <Typography variant="body">로그인</Typography>
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </StyledAppBar>
    </>
  );
};

export default Login;
